<template>
  <FlexContainer class="textInputContainer" :horizGap="1">
    <span v-if="title" :class="getInputClass()">{{ title }}</span>
    <input
      :id="`input-${title}`"
      :type="type"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </FlexContainer>
</template>

<script>
import FlexContainer from "./FlexContainer.vue";

export default {
  components: {
    FlexContainer,
  },

  props: {
    title: String,
    modelValue: [String, Number],
    type: {
      type: String,
      default: "number",
    },
  },

  methods: {
    getInputClass() {
      let classes = "";
      classes += "textInputHeader";
      if (this.modelValue || this.modelValue === 0) classes += " active";

      return classes;
    },
  },
};
</script>

<style scoped>
.textInputContainer {
  position: relative;
  .textInputHeader {
    position: absolute;
    top: 1.2rem;
    left: 0;
    transition: 0.3s ease;

    &.active {
      font-size: 0.75rem;
      top: 0.25rem;
    }
  }
}
</style>
